module.exports = __webpack_public_path__ + "img/guohuali.217343dd.jpg";